export function findInFormAnswer(input) {
  const form_answer = window["form_answer"];

  return form_answer?.answers[input.id];
}
